import { Download } from "lucide-react";
import { downloadReceipt } from "@/lib/receipt";

export const ReceiptButton = ({ receipt }) => <button className="receipt-button" onClick={() => downloadReceipt(receipt)} data-testid="download-receipt-button"><Download/> Télécharger le reçu PDF</button>;